import * as React from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
function SvgIconMfpSilhouette({
  title,
  titleId,
  ...props
}: React.SVGProps<SVGSVGElement> & SVGRProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      fill="none"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M6.23 3.964c-.036.117.07.293.292.492.2.176.832 1.02 1.418 1.887l1.055 1.559.012 1.137c.012.62.023 1.336.035 1.594.024.902-.152 1.805-.375 1.875-.258.082-1.91 1.113-2.543 1.582-.469.34-2.344 1.172-2.66 1.172-.083 0-.458.152-.844.351-.387.188-.774.352-.844.352-.082 0-.152.047-.152.106 0 .046.351.128.796.164.762.058.797.047 1.055-.27.2-.258.399-.351.82-.41 1.114-.14 2.134-.445 2.661-.774.293-.187 1.149-.656 1.899-1.043 1.476-.761 1.781-.82 2.789-.527 1.055.305 4.91 1.664 5.274 1.863.199.106.574.188.855.188.422 0 .504-.035.47-.2-.024-.152-.212-.234-.669-.292-.34-.059-.762-.2-.938-.317-.492-.351-1.664-.902-2.25-1.054-.293-.082-.797-.352-1.113-.61a10.216 10.216 0 00-1.184-.773c-.34-.176-.62-.387-.62-.47 0-.081-.153-.386-.34-.69-.34-.528-.34-.551-.165-.962.551-1.347.492-1.289 2.38-1.969.679-.234 1.394-.504 1.581-.586.2-.082.457-.14.586-.129.141.012.247-.058.27-.199.047-.199 0-.21-.574-.14-.352.046-.997.246-1.454.433-.515.211-1.02.34-1.383.34-.328 0-.75.094-1.02.235-.573.293-.608.128-.058-.282.293-.222.41-.41.41-.644 0-.621-.492-.774-1.289-.364-.433.223-.445.246-.316.575.14.386-.047.75-.328.644-.211-.082-2.672-3.07-2.918-3.527-.211-.422-.516-.575-.622-.317z"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgIconMfpSilhouette;
